/**
 * Çok noktalı (multi-city) uçak araması yardımcıları.
 *
 * Tasarım: arama formu tek bir çok-segmentli `AirSearchRequest` kurar (`flightType: 'MULTI'`,
 * `airSearchSegments` = her bacak, `sequenceNo` 1..N) ve bu istek OLDUĞU GİBİ tek bir
 * `Air/Search` çağrısına gider (bkz. api/endpoints/air.ts `searchAir` başlığı —
 * `Air/SearchMulti` legacy'de bile kullanılmıyor). Backend düz sonuçları bacak bazında
 * gruplayıp `AirSearchResponse.multiOriginDestinationOptions[bacakIndex]` altında döner.
 *
 * Akışın çok noktalı olup olmadığı `flowConfig.ts` / `resume.ts` içinde bu tek yordamdan
 * belirlenir; allocate/prebooking/finalize adımları buna göre `Air/*MultiCity` uçlarını seçer.
 */
import type { AirSearchRequest } from '../../api/types/air';

/** `searchRequest.airSearchOptions.flightType === 'MULTI'` — akışın çok noktalı uçları
 *  kullanıp kullanmayacağını belirleyen tek kaynak. */
export function isMultiCityRequest(request?: AirSearchRequest): boolean {
  return request?.airSearchOptions?.flightType === 'MULTI';
}
